import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import StatusBadge from "../components/StatusBadge";
import NotificationsBell from "../components/NotificationsBell";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { LogOut, ArrowRight, HardHat } from "lucide-react";

export default function ContractorHome() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation(["contractor", "common"]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/projects");
      setProjects(data.projects || []);
    })();
  }, []);

  const doLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="border-b border-[#EBE5D9]">
        <div className="max-w-4xl mx-auto flex items-center justify-between px-6 py-4">
          <div className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="OrkaiFlow" className="w-9 h-9 object-contain" />
            <span className="font-display text-xl font-semibold text-[#2C2A29]">OrkaiFlow</span>
          </div>
          <div className="flex items-center gap-2">
            <LanguageSwitcher variant="header" />
            <NotificationsBell />
            <button onClick={doLogout} data-testid="logout-btn" className="btn-ghost !p-2"><LogOut size={16} /></button>
          </div>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-10">
        <div className="text-xs uppercase tracking-widest font-bold text-[#7A7571]">{t("contractor:home.portal")}</div>
        <h1 className="font-display text-4xl font-bold text-[#2C2A29] mt-2">{t("contractor:home.hi", { name: user?.name?.split(" ")[0] || "" })}</h1>
        <p className="text-[#7A7571] mt-2 mb-8">{t("contractor:home.activeProjects")}</p>

        {projects.length === 0 && (
          <div className="card-soft text-center py-12">
            <p className="text-[#7A7571]">{t("contractor:home.noProjects")}</p>
          </div>
        )}

        <div className="space-y-4">
          {projects.map((p) => (
            <Link key={p.project_id} to={`/contractor/projects/${p.project_id}`}
              data-testid={`contractor-project-${p.project_id}`}
              className="card-soft flex items-center justify-between hover:-translate-y-0.5 transition-transform">
              <div>
                <div className="flex items-center gap-3 mb-1">
                  <HardHat size={16} className="text-[#E07A5F]" />
                  <h3 className="font-display text-xl font-semibold text-[#2C2A29]">{p.name}</h3>
                </div>
                <div className="text-sm text-[#7A7571]">{p.address}</div>
                {p.open_tasks > 0 && <div className="mt-2"><StatusBadge status="waiting_on_contractor" label={t("contractor:home.openTasks", { count: p.open_tasks })} /></div>}
              </div>
              <ArrowRight size={18} className="text-[#7A7571]" />
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
}
